export default "__VITE_ASSET__D8Id5swz__"